import { Clipboard } from '@angular/cdk/clipboard';
import { Component, effect, inject, input, model } from '@angular/core';

@Component({
  selector: 'shared-ui-copy-text',
  templateUrl: './copy-text.component.html',
  styleUrls: ['./copy-text.component.css'],
  imports: [],
})
export class CopyTextComponent {
  text = input.required<string | boolean | number>();

  isCopied = model(false);

  testId = input<string>();

  private readonly clipboard = inject(Clipboard);

  constructor() {
    effect(() => {
      if (this.isCopied()) {
        this.clipboard.copy(this.text().toString());
      }
    });
  }

  protected copyToClipboard(): void {
    this.isCopied.set(true);
  }
}
